import React, {ReactNode, useState} from 'react';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import CheckIcon from '@material-ui/icons/Check';
import './SubtleDropdown.sass';

type DropdownOption = {
  id: number | string;
  name: ReactNode;
};

interface SubtleDropdownProps {
  options: DropdownOption[];
  selected: number | string;
  onSelect: (id: number | string) => void;
  dropdownZIndex?: number;
}

export const SubtleDropdown = (props: SubtleDropdownProps) => {
  const {options, selected, onSelect, dropdownZIndex} = props;
  const selectedOption = options.find(option => option.id === selected);
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className="dropdown-container"
      style={{
        zIndex: dropdownZIndex ?? 1,
      }}
      onClick={() => setExpanded(expanded => !expanded)}>
      <div className="dropdown-value">
        <span className="underline">{selectedOption?.name ?? ''}</span>
        <KeyboardArrowUpIcon
          style={{
            rotate: expanded ? '0deg' : '180deg',
          }}
        />
      </div>
      <div className={`dropdown-select ${expanded && 'expanded'}`}>
        {options.map(option => (
          <div key={option.id} className="dropdown-option" onClick={() => onSelect(option.id)}>
            <CheckIcon
              fontSize="small"
              style={{
                visibility: option.id === selected ? 'visible' : 'hidden',
              }}
            />
            {option.name}
          </div>
        ))}
      </div>
    </div>
  );
};
